// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./assets/stylesheets/partials/new-project.scss
// module id = 451
// module chunks = 0